import { OpportunitiesSearchParams } from '~/contexts/types/opportunities/searchParams';

export const useConstants = () => {
  const defaultFromToRange = { from: '', to: '' };
  const defaultValues: OpportunitiesSearchParams = {
    loan_officer: {
      name: '',
      nmls: '',
    },
    company: {
      license: '',
      name: '',
      organization_type: [],
      address_state: '',
      strict: false,
    },
    address: {
      state: '',
      city: '',
      zip: '',
      county: '',
    },
    financial: {
      completion_date: defaultFromToRange,
      loan_amount: defaultFromToRange,
      sale_amount: defaultFromToRange,
      loan_type: '',
      loan_purpose: '',
      rate: defaultFromToRange,
      ltv: defaultFromToRange,
      rate_type: '',
      mortgage_term: defaultFromToRange,
    },
  };

  return {
    defaultValues,
  };
};
